import { BrowserRouter, Route, Switch } from "react-router-dom";

import App from "./components/App";
import Loadable from "react-loadable";
import Loading from "./components/helpers/loading";
import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
import withTracker from "./withTracker";
import SingleStore from "./components/Mobile/SingleStore";
import ItemsView from "./components/Mobile/SingleStore/ItemsView";
import SingleItem from "./components/Mobile/Items/SingleItem";
import SingleItemStore from "./components/Mobile/SingleStore/SingleItem";


// import NotFound from "./components/NotFound";
const NotFound = Loadable({
	loader: () => import("./components/NotFound"),
	loading: () => <Loading />,
});

// import Location from "./components/Mobile/Location";
const Location = Loadable({
	loader: () => import("./components/Mobile/Location"),
	loading: () => <Loading />,
});

// import Items from "./components/Mobile/Items";
// const Items = Loadable({
// 	loader: () => import("./components/Mobile/Items"),
// 	loading: () => <Loading />,
// });

// import Login from "./components/Mobile/Auth/Login";
const Login = Loadable({
	loader: () => import("./components/Mobile/Auth"),
	loading: () => <Loading />,
});

const ViewCoupons = Loadable({
	loader: () => import("./components/Mobile/ViewCoupons"),
	loading: () => <Loading />,
});



const ViewQuickBite = Loadable({
	loader: () => import("./components/Mobile/QuickBitesView"),
	loading: () => <Loading />,
});

// import Register from "./components/Mobile/Auth/Register";
const Register = Loadable({
	loader: () => import("./components/Mobile/Auth/Register"),
	loading: () => <Loading />,
});

// import CartPage from "./components/Mobile/Cart";
const CartPage = Loadable({
	loader: () => import("./components/Mobile/Cart"),
	loading: () => <Loading />,
});


// import Account from "./components/Mobile/Account";
const Account = Loadable({
	loader: () => import("./components/Mobile/Account"),
	loading: () => <Loading />,
});

// import Explore from "./components/Mobile/Explore";
const Explore = Loadable({
	loader: () => import("./components/Mobile/Explore"),
	loading: () => <Loading />,
});

// import Addresses from "./components/Mobile/Account/Addresses";
const Addresses = Loadable({
	loader: () => import("./components/Mobile/Account/Addresses"),
	loading: () => <Loading />,
});

// import Checkout from "./components/Mobile/Checkout";
const Checkout = Loadable({
	loader: () => import("./components/Mobile/Checkout"),
	loading: () => <Loading />,
});

// import RunningOrder from "./components/Mobile/RunningOrder";
const RunningOrder = Loadable({
	loader: () => import("./components/Mobile/RunningOrder"),
	loading: () => <Loading />,
});

// import Orders from "./components/Mobile/Account/Orders";
const Orders = Loadable({
	loader: () => import("./components/Mobile/Account/Orders"),
	loading: () => <Loading />,
});

// import WalletPage from "./components/Mobile/Account/Wallet";
const WalletPage = Loadable({
	loader: () => import("./components/Mobile/Account/Wallet"),
	loading: () => <Loading />,
});
/* Delivery */
// import Delivery from "./components/Delivery";
const Delivery = Loadable({
	loader: () => import("./components/Delivery"),
	loading: () => <Loading />,
});

// import DeliveryLogin from "./components/Delivery/Login";
const DeliveryLogin = Loadable({
	loader: () => import("./components/Delivery/Login"),
	loading: () => <Loading />,
});

// import DeliveryOrders from "./components/Delivery/Orders";
const DeliveryOrders = Loadable({
	loader: () => import("./components/Delivery/Orders"),
	loading: () => <Loading />,
});

// import ViewOrder from "./components/Delivery/ViewOrder";
const ViewOrder = Loadable({
	loader: () => import("./components/Delivery/ViewOrder"),
	loading: () => <Loading />,
});

// import GeoLocationPage from "./components/Mobile/GeoLocationPage";
const GeoLocationPage = Loadable({
	loader: () => import("./components/Mobile/GeoLocationPage"),
	loading: () => <Loading />,
});

// import SingleItem from "./components/Mobile/Items/SingleItem";
// const SingleItem = Loadable({
// 	loader: () => import("./components/Mobile/Items/SingleItem"),
// 	loading: () => <Loading />,
// });

const ItemsParent = Loadable({
	loader: () => import("./components/Mobile/Items/ItemsParent"),
	loading: () => <Loading />,
});

const SingleItemParent = Loadable({
	loader: () => import("./components/Mobile/Items/SingleItemParent"),
	loading: () => <Loading />,
});

const SinglePage = Loadable({
	loader: () => import("./components/SinglePage"),
	loading: () => <Loading />,
});

const ForgotPassword = Loadable({
	loader: () => import("./components/Mobile/Auth/ForgotPassword"),
	loading: () => <Loading />,
});

const RestaurantListOnCategory = Loadable({
	loader: () => import("./components/Mobile/Home/RestaurantListOnCategory"),
	loading: () => <Loading />,
});

const RatingAndReview = Loadable({
	loader: () => import("./components/Mobile/Account/Orders/RatingAndReview"),
	loading: () => <Loading />,
});
const ViewStoreReviews = Loadable({
	loader: () => import("./components/Mobile/StoreReviews"),
	loading: () => <Loading />,
});

const Alerts = Loadable({
	loader: () => import("./components/Mobile/Alerts"),
	loading: () => <Loading />,
});

// const TestComponent = Loadable({
// 	loader: () => import("./components/Mobile/TestComponent/List"),
// 	loading: () => <Loading />,
// });


// import CartPage from "./components/Mobile/Cart";
const HomeFront = Loadable({
	loader: () => import("./components/Mobile/HomeFront"),
	loading: () => <Loading />,
});

const OfferSection = Loadable({
	loader: () => import("./components/Mobile/OfferSection"),
	loading: () => <Loading />,
});

const StoreType = Loadable({
	loader: () => import("./components/Mobile/Home/StoreType"),
	loading: () => <Loading />,
});

/* STORE */

// import Delivery from "./components/Delivery";
const Store = Loadable({
	loader: () => import("./components/Store"),
	loading: () => <Loading />,
});

// import StoreLogin from "./components/Store/Login";
const StoreLogin = Loadable({
	loader: () => import("./components/Store/Login"),
	loading: () => <Loading />,
});

const StoreAccount = Loadable({
	loader: () => import("./components/Store/Dashboard/Account"),
	loading: () => <Loading />,
});


// import StoreLogin from "./components/Store/Login";
const StoreDashboard = Loadable({
	loader: () => import("./components/Store"),
	loading: () => <Loading />,
});

const StoreReports = Loadable({
	loader: () => import("./components/Store/Dashboard/Reports"),
	loading: () => <Loading />,
});

const StoreOrders = Loadable({
	loader: () => import("./components/Store/Dashboard/Orders"),
	loading: () => <Loading />,
});

const StoreProducts = Loadable({
	loader: () => import("./components/Store/Dashboard/Products"),
	loading: () => <Loading />,
});

const StoreViewProducts = Loadable({
	loader: () => import("./components/Store/Dashboard/Products/View"),
	loading: () => <Loading />,
});


const OrderView = Loadable({
	loader: () => import("./components/Store/Dashboard/Orders/OrderView"),
	loading: () => <Loading />,
});

const Rewards = Loadable({
	loader: () => import("./components/Mobile/Account/Rewards"),
	loading: () => <Loading />,
});


/* Store End */

const ScrollToTop = () => {
	window.scrollTo(0, 0);
	return null;
};

ReactDOM.render(
	<Root>
		<BrowserRouter>
			<React.Fragment>
				<Route component={ScrollToTop} />
				<Switch>
					{/* <Route exact strict  path="/:url*" render={props => <Redirect to={`${props.location.pathname}/`} />} /> */}
					<Route path={"/"} exact component={withTracker(App)} />

					{/* Test Routes*/}
					{/* <Route path={"/saurabh/test"} exact component={TestComponent} /> */}

					<Route path={"/search-location"} exact component={withTracker(Location)} />
					<Route path={"/my-location"} exact component={withTracker(GeoLocationPage)} />
					<Route path={"/home-front"} exact component={withTracker(HomeFront)} />
					<Route path={"/offer-section/:tag"} exact component={withTracker(OfferSection)} />
					<Route path={"/store-type/:type"} exact component={withTracker(StoreType)} />
					<Route path={"/coupon/:id"} exact component={withTracker(ViewCoupons)} />
					<Route path={"/quick-bites/:quick_bite"} exact component={withTracker(ViewQuickBite)} />
					<Route path={"/rate-order/:id"} exact component={withTracker(RatingAndReview)} />
					<Route path={"/reviews/:slug"} exact component={withTracker(ViewStoreReviews)} />


					<Route path={"/categories/stores"} exact component={withTracker(RestaurantListOnCategory)} />

					{/* <Route path={"/stores/:restaurant"} exact component={withTracker(Items)} /> */}
					<Route path={"/stores/:restaurant"} exact component={withTracker(ItemsParent)} />
					{/* <Route path={"/stores/:restaurant/:id"} exact component={withTracker(SingleItem)} /> */}
					<Route path={"/stores/:restaurant/:id"} exact component={withTracker(SingleItemParent)} />

					<Route path={"/explore"} exact component={withTracker(Explore)} />

					<Route path={"/login"} exact component={withTracker(Login)} />
					<Route path={"/login/forgot-password"} exact component={withTracker(ForgotPassword)} />
					<Route path={"/register"} exact component={withTracker(Register)} />

					<Route path={"/my-account"} exact component={withTracker(Account)} />
					<Route path={"/alerts"} exact component={withTracker(Alerts)} />
					<Route path={"/my-addresses"} exact component={withTracker(Addresses)} />
					<Route path={"/my-wallet"} exact component={withTracker(WalletPage)} />
					<Route path={"/my-orders"} exact component={withTracker(Orders)} />
					<Route path={"/rate-and-review/:id"} exact component={withTracker(RatingAndReview)} />
					<Route path={"/account/rewards"} exact component={withTracker(Rewards)} />


					<Route path={"/checkout"} exact component={withTracker(Checkout)} />
					<Route path={"/running-order/:unique_order_id"} exact component={withTracker(RunningOrder)} />

					<Route path={"/cart"} exact component={withTracker(CartPage)} />

					<Route path={"/pages/:slug"} exact component={withTracker(SinglePage)} />

					{/* Delivery Routes */}
					<Route path={"/delivery"} exact component={Delivery} />
					<Route path={"/delivery/login"} exact component={DeliveryLogin} />
					<Route path={"/delivery/orders"} exact component={DeliveryOrders} />
					<Route path={"/delivery/orders/:unique_order_id"} exact component={ViewOrder} />
					<Route path={"/delivery/completed-orders"} exact component={Delivery} />

					{/* Restaurant Owner Routes*/}
					<Route path={"/store/login"} exact component={StoreLogin} />
					<Route path={"/store/dashboard"} exact component={StoreDashboard} />
					<Route path={"/store/orders/:date"} exact component={StoreOrders} />
					<Route path={"/store/order/view/:unique_order_id"} exact component={OrderView} />
					<Route path={"/store/products"} exact component={StoreProducts} />
					<Route path="/store/view/product/:product_id" component={StoreViewProducts} />
					<Route path="/store/account" component={StoreAccount} />
					<Route path="/store/reports" component={StoreReports} />


					{/* Restaurant Owner Routes End*/}

					{/* Common Routes */}
					<Route path="/single-store-view-more/:id" component={ItemsView} />
					<Route path="/single-store-category/:id/:store_id" component={ItemsView} />
					<Route path="/single-store/:type_id" component={SingleStore} />
					<Route path="/single-store-single_item/:id" component={SingleItemStore} />



					<Route component={NotFound} />
				</Switch>
			</React.Fragment>
		</BrowserRouter>
	</Root>,
	document.getElementById("root")
);
